/**
 * Utils to add an event listener to a DOM element, and return a function to remove it.
 */
export default function(element: HTMLElement | Document | Window, event: string, handler: EventListenerOrEventListenerObject): () => void {
    element.addEventListener(event, handler);
    return () => element.removeEventListener(event, handler);
}
